export const customTextField = {
  background: "#FAFAFA",
  "& label.Mui-focused": {
    color: "#A0AAB4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B2BAC2",
  },
  "& .MuiOutlinedInput-input": {
    padding: "10px 12px 10px 0px",
    fontSize: "14px",
  },
  "& .MuiOutlinedInput-root": {
    paddingLeft: "12px",
    "& fieldset": {
      borderColor: "rgba(0,0,0,0)",
    },
    "&:hover fieldset": {
      borderColor: "#969696",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#969696",
    },
  },
};
